import type { ReactNode } from 'react';
import {
    AuthContext,
    DataProviderContext,
    StoreContextProvider,
    NotificationContextProvider,
    I18nContextProvider,
    localStorageStore,
} from 'ra-core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';

const store = localStorageStore();
const queryClient = new QueryClient();

export function AdminProviders({ children }: { children: ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthContext.Provider value={authProvider}>
                <DataProviderContext.Provider value={dataProvider as any}>
                    <StoreContextProvider value={store}>
                        <NotificationContextProvider>
                            <I18nContextProvider value={undefined}>
                                <BrowserRouter>{children}</BrowserRouter>
                            </I18nContextProvider>
                        </NotificationContextProvider>
                    </StoreContextProvider>
                </DataProviderContext.Provider>
            </AuthContext.Provider>
        </QueryClientProvider>
    );
}
